export default __webpack_public_path__ + "static/media/pw.c0deb8bf.svg";